var audio_rtlignore_default = {
  "fontElementMap": "_6I3YB",
  "container": "b6zPz",
  "customPlayer": "j6Jau",
  "slim": "mRIsb",
  "playPauseButton": "-nAgW",
  "coverImage": "EXLq8",
  "trackDetailsContainer": "BmPqW",
  "controlsContainer": "s7cOA",
  "controlsGroup": "Ruv4W",
  "sliderContainer": "BPSls",
  "audioDuration": "WxH-M",
  "isLoading": "OiB4C",
  "audioDetails": "YoEyj",
  "authorName": "h68us",
  "title": "TCJpj",
  "dropdownMenuWrapper": "vUMbu",
  "dropdownSelectedButton": "KLsDs",
  "dropdownContent": "d09Kg",
  "dropdownContentWithIcon": "h0uqb",
  "audioLoader": "_2Aqmd"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
